import Inactive from "./Inactive.jsx";
export default Inactive;